{
	"Country": [
	  "Singapore",
	  "Hong Kong",
	  "Australia"
	],
	"Type": [
	  {
		"Personal Card": "Individual"
	  },
	  {
		"Corporate Card": "Business"
	  }
	],
	"Card Type": [
	  "Miles",
	  "Cash Back",
	  "Regular"
	],
	"cards": {
	  "Singapore Individual": [
		"Citi Premier Miles Card",
		"HSBC Travel One Card",
		"UOB Krisflyer Credit Card",
		"UOB Privi Miles",
		"Standard Chartered Journey Credit Card",
		"OCBC 90 Deg Visa Card",
		"HSBC Visa Infinite",
		"UOB Visa Infinite",
		"Cash Back Card (Singapore)"
	  ],
	  "Hong Kong Individual": [
		"Citi Premier Miles",
		"HSBC Everyday miles",
		"MOX Credit Card",
		"Standard Chartered Cathay Mastercard",
		"HSBC Visa Platinum Card",
		"Citi Prestige",
		"Cash Back Card (Hong Kong)"
	  ],
	  "Australia Individual": [
		"Qantas Premier Platinum",
		"Qantas Premier Everyday",
		"Westpac Altitude Black",
		"Westpac Altitude Platinum",
		"ANZ Rewards Black",
		"ANZ Frequent Flyer Platinum",
		"Citi Premier Qantas",
		"NAB Qantas Rewards Signature",
		"Commonwealth Ultimate Awards",
		"Cash Back Card (Australia)"
	  ],
	  "Singapore Business": [
		"Corporate Card with no miles",
		"Corporate Card with miles",
		"Corporate card with cashback"
	  ],
	  "Hong Kong Business": [
		"Corporate Card with no miles",
		"Corporate Card with miles",
		"Corporate card with cashback"
	  ],
	  "Australia Business": [
		"Corporate Card with no miles",
		"Corporate Card with miles",
		"Corporate card with cashback"
	  ]
	},
	"earnrate": [
	  {
		"card": "Citi Premier Miles Card",
		"cost": "2.50",
		"milesEarned": "1.2"
	  },
	  {
		"card": "HSBC Travel One Card",
		"cost": "2.50",
		"milesEarned": "1.2"
	  },
	  {
		"card": "UOB Krisflyer Credit Card",
		"cost": "2.50",
		"milesEarned": "1.2"
	  },
	  {
		"card": "UOB Privi Miles",
		"cost": "2.50",
		"milesEarned": "1.4"
	  },
	  {
		"card": "Standard Chartered Journey Credit Card",
		"cost": "2.50",
		"milesEarned": "1.2"
	  },
	  {
		"card": "OCBC 90 Deg Visa Card",
		"cost": "2.50",
		"milesEarned": "1.3"
	  },
	  {
		"card": "HSBC Visa Infinite",
		"cost": "2.50",
		"milesEarned": "1.25"
	  },
	  {
		"card": "UOB Visa Infinite",
		"cost": "2.50",
		"milesEarned": "1.4"
	  },
	  {
		"card": "DBS Altitude",
		"cost": "2.50",
		"milesEarned": "1.4"
	  },
	  {
		"card": "Citi Premier Miles",
		"cost": "1.50",
		"milesEarned": "0.125"
	  },
	  {
		"card": "HSBC Everyday miles",
		"cost": "1.50",
		"milesEarned": "0.111111111"
	  },
	  {
		"card": "MOX Credit Card",
		"cost": "1.50",
		"milesEarned": "0.25"
	  },
	  {
		"card": "Standard Chartered Cathay Mastercard",
		"cost": "1.50",
		"milesEarned": "0.166666667"
	  },
	  {
		"card": "HSBC Visa Platinum Card",
		"cost": "1.50",
		"milesEarned": "0.239808153"
	  },
	  {
		"card": "Citi Prestige",
		"cost": "1.50",
		"milesEarned": "0.166666667"
	  },
	  {
		"card": "Qantas Premier Platinum",
		"cost": "1.50",
		"milesEarned": "1"
	  },
	  {
		"card": "Qantas Premier Everyday",
		"cost": "1.50",
		"milesEarned": "0.75"
	  },
	  {
		"card": "Westpac Altitude Black",
		"cost": "1.50",
		"milesEarned": "1.25"
	  },
	  {
		"card": "Westpac Altitude Platinum",
		"cost": "1.50",
		"milesEarned": "1"
	  },
	  {
		"card": "ANZ Rewards Black",
		"cost": "1.50",
		"milesEarned": "0.5"
	  },
	  {
		"card": "ANZ Frequent Flyer Platinum",
		"cost": "1.50",
		"milesEarned": "0.75"
	  },
	  {
		"card": "Citi Premier Qantas",
		"cost": "1.50",
		"milesEarned": "1"
	  },
	  {
		"card": "NAB Qantas Rewards Signature",
		"cost": "1.50",
		"milesEarned": "1"
	  },
	  {
		"card": "Commonwealth Ultimate Awards",
		"cost": "1.50",
		"milesEarned": "1.2"
	  },
	  {
		"card": "Cash Back Card (Singapore)",
		"cost": "2.50",
		"miles" : false,
		"cashback" : true,
		"milesEarned": "0"
	  },
	  {
		"card": "Cash Back Card (Hong Kong)",
		"cost": "1.50",
		"miles" : false,
		"cashback" : true,
		"milesEarned": "0"
	  },
	  {
		"card": "Cash Back Card (Australia)",
		"cost": "1.50",
		"miles" : false,
		"cashback" : true,
		"milesEarned": "0"
	  },
	  {
		"card": "Corporate Card with no miles",
		"cost": "2.50",
		"miles" : false,
		"cashback" : false,
		"milesEarned": "0"
	  },
	  {
		"card": "Corporate Card with miles",
		"cost": "2.50",
		"miles" : true,
		"cashback" : false,
		"milesEarned": "0.3"
	  },

	  {
		"card": "Corporate card with cashback",
		"cost": "2.50",
		"miles" : false,
		"cashback" : true,
		"milesEarned": "0"
	  }
	],
	"Airlines": {
	  "Singapore": {
		"Singapore Airlines": {
		  "class": {
			"Business": {
			  "SIN-BOM": {
				"miles_needed": 80000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to Mumbai"
			  },
			  "SIN-DEL": {
				"miles_needed": 80000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to Delhi"
			  },
			  "SIN-DXB": {
				"miles_needed": 80000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to Dubai"
			  },
			  "SIN-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to London"
			  },
			  "SIN-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to New York"
			  }
			},
			"Economy": {
			  "SIN-BOM": {
				"miles_needed": 40000,
				"miles_pricing": 0.017,
				"trip_details": "Singapore to Mumbai"
			  },
			  "SIN-DEL": {
				"miles_needed": 40000,
				"miles_pricing": 0.017,
				"trip_details": "Singapore to Delhi"
			  },
			  "SIN-DXB": {
				"miles_needed": 40000,
				"miles_pricing": 0.017,
				"trip_details": "Singapore to Dubai"
			  },
			  "SIN-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to London"
			  },
			  "SIN-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 0.035,
				"trip_details": "Singapore to New York"
			  }
			}
		  }
		}
	  },
	  "Hong Kong": {
		"Cathay Pacific": {
		  "class": {
			"Business": {
			  "HKG-BOM": {
				"miles_needed": 13000,
				"miles_pricing": 1.035,
				"trip_details": "Hong Kong to Mumbai"
			  },
			  "HKG-DEL": {
				"miles_needed": 13000,
				"miles_pricing": 1.035,
				"trip_details": "Hong Kong to Delhi"
			  },
			  "HKG-DXB": {
				"miles_needed": 13000,
				"miles_pricing": 1.035,
				"trip_details": "Hong Kong to Dubai"
			  },
			  "HKG-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 1.035,
				"trip_details": "Hong Kong to London"
			  },
			  "HKG-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 1.035,
				"trip_details": "Hong Kong to New York"
			  }
			},
			"Economy": {
			  "HKG-BOM": {
				"miles_needed": 13000,
				"miles_pricing": 2.035,
				"trip_details": "Hong Kong to Mumbai"
			  },
			  "HKG-DEL": {
				"miles_needed": 13000,
				"miles_pricing": 2.035,
				"trip_details": "Hong Kong to Delhi"
			  },
			  "HKG-DXB": {
				"miles_needed": 13000,
				"miles_pricing": 2.035,
				"trip_details": "Hong Kong to Dubai"
			  },
			  "HKG-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 2.035,
				"trip_details": "Hong Kong to London"
			  },
			  "HKG-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 2.035,
				"trip_details": "Hong Kong to New York"
			  }
			}
		  }
		}
	  },
	  "Australia": {
		"Qantas": {
		  "class": {
			"Business": {
			  "SYD-BOM": {
				"miles_needed": 13000,
				"miles_pricing": 3.035,
				"trip_details": "Sydney to Mumbai"
			  },
			  "SYD-DEL": {
				"miles_needed": 13000,
				"miles_pricing": 3.035,
				"trip_details": "Sydney to Delhi"
			  },
			  "SYD-DXB": {
				"miles_needed": 13000,
				"miles_pricing": 3.035,
				"trip_details": "Sydney to Dubai"
			  },
			  "SYD-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 3.035,
				"trip_details": "Sydney to London"
			  },
			  "SYD-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 3.035,
				"trip_details": "Sydney to New York"
			  }
			},
			"Economy": {
			  "SYD-BOM": {
				"miles_needed": 13000,
				"miles_pricing": 4.035,
				"trip_details": "Sydney to Mumbai"
			  },
			  "SYD-DEL": {
				"miles_needed": 13000,
				"miles_pricing": 4.035,
				"trip_details": "Sydney to Delhi"
			  },
			  "SYD-DXB": {
				"miles_needed": 13000,
				"miles_pricing": 4.035,
				"trip_details": "Sydney to Dubai"
			  },
			  "SYD-LHR": {
				"miles_needed": 13000,
				"miles_pricing": 4.035,
				"trip_details": "Sydney to London"
			  },
			  "SYD-JFK": {
				"miles_needed": 13000,
				"miles_pricing": 4.035,
				"trip_details": "Sydney to New York"
			  }
			}
		  }
		}
	  }
	}
  }